// @flow
import React from 'react';
import styled from 'styled-components';
import { font } from 'styles/Constants';
import InfoIcon from 'AssetsRoot/images/icons/infocircle.svg.react';
import accounting from 'accounting';

const BoxContentInfo = styled.div`
  width: 300px;
  margin: 0 auto;
  padding: 16px 0;
  border-top: 1px solid #f0f0f0;
`;

const Tooltip = styled.ul`
  position: absolute;
  background-color: #fffdf6;
  border: 1px solid;
  border-radius: 6px;
  box-shadow: 0px 4px 4px 0px rgb(0 0 0 / 25%);
  color: #535353;
  padding: 16px 14px;    
  width: 300px;
  top: 30px;
  left: -97px;
  visibility: hidden;
  opacity: 0;
  transition: opacity .5s;
  z-index: 1;

  li {
    list-style: none;
    position: relative;
    padding-left: 12px;
      &::before {
        content: "·";
        font-size: 25px;
        position: absolute;
        left: 0;
        top: -8px;
    }
  }
  &::after {
    position: absolute;
    content: "";
    width: 0; 
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    top: -6px;
    border-bottom: 7px solid #FFFDF6;
    left: 100px;
  }
  
  &::before {
    position: absolute;
    content: "";
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 7px solid;
    top: -8px;
    left: 100px;
  }
}
  }
`;
const Title = styled.div`
  height: 19px;
  color: #161628;
  font-family: ${font.openSans};
  font-size: 16px;
  line-height: 19px;
  font-weight: bold;
`;

const SummaryContainer = styled.ul`
  margin: 32px 0 0 0;
  padding: 0;
  width: 100%;
`;
const SummaryItemComponent = styled.li`
  list-style: none;
  width: 100%;
  display: inline-block;
  color: #535353;
  margin-bottom: 18px;
`;
const SummaryItemTitle = styled.span`
  float: left;
  max-width: 55%;
`;
const SummaryItemValue = styled.span`
  float: right;
  max-width: 45%;
`;
const SummaryTotal = styled(SummaryItemComponent)`
  font-weight: bold;
  border-top: 1px solid;
  padding-top: 8px;
  color: #161628;
  margin: 0;
`;

const InfoIconContainer = styled.span`
  position: relative;
  width: 18px;
  height: 18px;
  display: block;
  float: right;
  margin-left: 5px;

  &:hover {
    ul {
      opacity: 1;
      visibility: visible;
    }
  }
`;
const InfoIconSVG = styled(InfoIcon)`
  display: block;
  float: right;
  margin-left: 5px;
`;

const AmountToPay = styled.p`
  font-size: 15px;
  margin-bottom: 18px;
  color: #535353 !important;
`;

const Amount = styled.p`
  color: #535353 !important;
  font-size: 15px;
`;

const AmountContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

type State = {
  paymentFee: number,
  selectedOption: boolean
};

export type SummaryItem = {
  id: string,
  title: string,
  value: string,
  info?: string[]
};
export type Summary = {
  items: SummaryItem[],
  total?: SummaryItem
};

type PropsType = {
  summary: Summary,
  prePaymentValue: number,
  prePaymentCurrency: string
};

export default class SummaryPayment extends React.Component<PropsType, State> {
  constructor(props: PropsType) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <BoxContentInfo>
        <Title>Resumen</Title>
        <SummaryContainer>
          <AmountContainer>
            <AmountToPay>Importe a pagar</AmountToPay>
            <Amount>
              {accounting.formatMoney(this.props.prePaymentValue)}{' '}
              {this.props.prePaymentCurrency}
            </Amount>
          </AmountContainer>
          {this.props.summary.items.map(item => (
            <SummaryItemComponent key={item.id}>
              <SummaryItemTitle>
                {item.title}{' '}
                {item.info ? (
                  <InfoIconContainer>
                    <InfoIconSVG />
                    <Tooltip>
                      {item.info.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </Tooltip>
                  </InfoIconContainer>
                ) : (
                  ''
                )}
              </SummaryItemTitle>
              <SummaryItemValue>{item.value}</SummaryItemValue>
            </SummaryItemComponent>
          ))}
          <SummaryTotal key={this.props.summary.total.id}>
            <SummaryItemTitle>
              {this.props.summary.total.title}
            </SummaryItemTitle>
            <SummaryItemValue>
              {this.props.summary.total.value}
            </SummaryItemValue>
          </SummaryTotal>
        </SummaryContainer>
      </BoxContentInfo>
    );
  }
}
